import { FC, useState } from 'react';
import { CustomerCoupons } from '@models';
import { Grid, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useAppDispatch } from '@hooks/redux-custom';
import { useSyncVoucherMutation } from '@services';
import { showToast } from '@store/slices/notification';

type Props = {
  loyaltylist: CustomerCoupons | undefined;
  customerId: number;
};

const LoyaltyList: FC<Props> = ({ loyaltylist, customerId }) => {
  const [executeSyncVoucher] = useSyncVoucherMutation();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();

  const syncVoucher = async () => {
    setIsLoading(true);

    executeSyncVoucher({
      customerId,
    }).then((data) => {
      dispatch(showToast({ type: 'success', message: `Successfully synced the vouchers, please refresh the page!` }));
      setIsLoading(false);
    });
  };

  if (!loyaltylist) {
    return (
      <div>
        <Typography variant="h6">No Loyalty List</Typography>
      </div>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Typography variant="body1">Loyalty Order Count</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography variant="body2">{loyaltylist.profile?.attributes.loyalty_order_count}</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography variant="body1">Voucher Value</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography variant="body2">{loyaltylist.profile?.attributes.voucher_value}</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography variant="body1">Loyalty Cycle</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography variant="body2">{loyaltylist.profile?.attributes.loyalty_cycle}</Typography>
      </Grid>
      <Grid item xs={12} sm={12}>
        <LoadingButton
          loading={isLoading}
          variant="contained"
          data-testid="sync-voucher-btn"
          startIcon={<CurrencyExchangeIcon />}
          onClick={syncVoucher}
        >
          Sync voucher
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default LoyaltyList;
